import { render, staticRenderFns } from "./AddProjectDialog.vue?vue&type=template&id=6c31242b"
import script from "./AddProjectDialog.vue?vue&type=script&lang=js"
export * from "./AddProjectDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports